'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _GlobalOutlined = _interopRequireDefault(require('./lib/icons/GlobalOutlined'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _GlobalOutlined;
  exports.default = _default;
  module.exports = _default;